<template>
  <div class="walk-analytics">
    <div class="statistical-data">
      <el-row :gutter="15">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('walkAnalysics.totalWalkersCount') }}
            </div>
            <div class="statistics">
              {{ data.total_walkers_count }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('walkAnalysics.thisMonthActiveWalkersCount') }}
            </div>
            <div class="statistics">
              {{ data.this_month_active_walkers_count }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('walkAnalysics.lastHourActiveWalkersCount') }}
            </div>
            <div class="statistics">
              {{ data.last_hour_active_walkers_count }}
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="15">
        <el-col :span="12">
          <el-card>
            <div>
              <ECharts :options="newJoinedTrendLineOptions" style="width:100%" />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="walkers-columns">
      <bean-source-page
        type="index"
        :columns="walkerColumns"
        :form-columns="[]"
        :filter-columns="[]"
        :form="{}"
        :actionButtons="[]"
        title=""
        :actions="[]"
        resource="walk/analytics/walkers"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import _ from 'lodash';

@Component({
  components: {
    ECharts
  }
})
export default class walkAnalysics extends Vue {
  data = {}

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }


  get walkerColumns() {
    return [
      {
        prop: 'phone',
        label: this.$t('model.user'),
        minWidth: 150,
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row) {
            return <bean-link KeepNode to={{ name: 'users.show', params: { id: row.user_id } }}>{ row.phone }</bean-link>
          }
        }
      },
      {
        prop: 'walk_joined_at',
        label: this.$t('walkAnalysics.walkJoinedAt'),
        renderCell: 'time',
        minWidth: 150,
      },
      {
        prop: 'total_kilometers_distance',
        label: this.$t('walkAnalysics.totalKilometersDistance'),
        minWidth: 150,
      },
      {
        prop: 'walk_last_active_at',
        label: this.$t('walkAnalysics.walkLastActiveAt'),
        renderCell: 'time',
        minWidth: 150,
      },
    ]
  }

  async mounted() {
    const data = await this.$request.get(`/walk/analytics`);
    this.data = data;
  }

  get newJoinedTrendLineOptions() {
    const legendData = [this.$t('walkAnalysics.newJoinedCount'), this.$t('walkAnalysics.ActivedWakerCount')]

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.new_joined_walkers_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.data.new_joined_walkers_trend,
        this.data.active_walkers_trend
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }
}

export const route = [
  {
    path: '/walk/analytics',
    name: 'walk_analytics',
    meta: {
      can: []
    },
    component: walkAnalysics,
  }
]
</script>

<style lang="scss">
  .walk-analytics {
    .statistical-data {
      margin: 15px;;
    }

    .el-row {
      margin-bottom: 20px;
    }

    .el-card {
      .el-card__header {
        padding: 10px;
        font-size: 14px;
        color: #909399;
        text-align: center;
        font-weight: bold;
      }

      .statistics {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
</style>
